import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TypeaheadComponent } from './typeahead.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RichWarningMessageModule } from '@components/rich-warning-message/rich-warning-message.module';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [TypeaheadComponent],
  imports: [CommonModule, NgbModule, ReactiveFormsModule, FormsModule, RichWarningMessageModule, SharedModule],
  exports: [TypeaheadComponent]
})
export class TypeaheadModule {}
